import { z } from 'zod';
import { FlowDataSchema } from './flowData.js';
import { FlowKind } from '../flow/enums.js';
import { FlowPricingMode } from '../flow/pricingMode.js';
/**
 * flow_definitions.state values
 * State Lifecycle Rules:
 * - Only 1 def per flow in [Draft & Review]
 * - Only 1 def per flow in [Published]
 * - When a def is published, existing published -> Superseded
 * - Can only Publish from Review state
 */
export var FlowDefinitionState;
(function (FlowDefinitionState) {
    FlowDefinitionState["Draft"] = "Draft";
    FlowDefinitionState["Review"] = "Review";
    FlowDefinitionState["Published"] = "Published";
    FlowDefinitionState["Superseded"] = "Superseded";
    FlowDefinitionState["SoftDeleted"] = "SoftDeleted";
})(FlowDefinitionState || (FlowDefinitionState = {}));
/** Every state but `SoftDeleted` — what a definition query returns unless it opts into deleted rows. */
export const ActiveFlowDefinitionStates = Object.values(FlowDefinitionState).filter((state) => state !== FlowDefinitionState.SoftDeleted);
/**
 * A flow definition joined with its flow, as flow-api serves it, without the `data`
 * block graph. `Date` columns are ISO strings.
 */
export const FlowDefinitionWithFlowBasicSchema = z.object({
    id: z.uuid(),
    flowId: z.uuid(),
    version: z.number(),
    state: z.enum(FlowDefinitionState),
    created: z.iso.datetime(),
    updated: z.iso.datetime(),
    lastSnapshotId: z.string().nullable(),
    supersededById: z.string().nullable(),
    notes: z.string().nullable(),
    createdById: z.string().nullable(),
    updatedById: z.string().nullable(),
    createdByEmail: z.string().nullable(),
    updatedByEmail: z.string().nullable(),
    name: z.string(),
    description: z.string().nullable(),
    kind: z.enum(FlowKind),
    organizationId: z.string(),
    agentId: z.string().nullable(),
    pricingMode: z.enum(FlowPricingMode).nullable(),
    /** Only selected when fetching a single definition. */
    documentationMarkdown: z.string().nullish(),
});
/** A complete flow definition as returned by flow-api, including its executable graph. */
export const FlowDefinitionWithFlowSchema = FlowDefinitionWithFlowBasicSchema.extend({
    data: FlowDataSchema,
});
/** A flow definition returned by the collection endpoint with its run count. */
export const FlowDefinitionForListSchema = FlowDefinitionWithFlowSchema.extend({
    runs: z.number(),
});
//# sourceMappingURL=flowDefinition.js.map